// extracted by mini-css-extract-plugin
export default {"large-profile-image-wrapper":"large-profile-image-wrapper-d88a","image":"image-0bab","withHover":"withHover-53f0"};